import { useEffect, useState } from "react";
import LogInCode from "components/LogIn/LogInCode";
import LogInNumber from "components/LogIn/LogInNumber";
export default function LogInNumberSabad({
  ChangeModalStar,
  changeUserInformation,
  item,
  setItems,
}) {
  const [modal, setmodal] = useState(0);
  const [loginkey, setloginkey] = useState("");
  const [number, setnumber] = useState("");
  useEffect(() => {
    (() => {
      "use strict";

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.querySelectorAll(".needs-validation");
      // Loop over them and prevent submission
      Array.prototype.slice.call(forms).forEach((form) => {
        form.addEventListener(
          "submit",
          (event) => {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }
            event.preventDefault();
            form.classList.add("was-validated");
          },
          false
        );
      });
    })();
  }, []);
  let SetNumber = (e) => {
    setnumber(e.target.value);
  };
  function changemodal(modalNumber) {
    setmodal(modalNumber);
  }
  function LoginKey(loginKey) {
    setloginkey(loginKey);
  }
  function Back() {
    setmodal(0);
  }
  let SendCode = () => {
    ChangeModalStar(0);
  };
  return (
    <form className="needs-validation " noValidate onSubmit={SendCode}>
      <div className=" d-flex justify-content-between">
        <div className="d-flex w-100  flex-column align-items-center justify-content-evenly ">
          {modal == 0 ? (
            <LogInNumber
              SetNumber={SetNumber}
              number={number}
              login={LoginKey}
              ChangeModal={changemodal}
            />
          ) : (
            <LogInCode
              ChangeModal={changemodal}
              loginkey={loginkey}
              SetNumber={SetNumber}
              changeUserInformation={changeUserInformation}
              number={number}
              ChangeModalStar={ChangeModalStar}
              item={item}
              setItems={setItems}
            />
          )}
        </div>
      </div>
    </form>
  );
}
